/** One block of the gallery: a heading, a line on how to use it, and the examples. */
const GallerySection = ({ id, title, description, children }) => {
  return (
    <section className="gallery-section" id={id} aria-labelledby={`${id}-title`}>
      <div className="gallery-section__heading">
        <h2 className="gallery-section__title" id={`${id}-title`}>
          {title}
        </h2>
        {description && <p className="gallery-section__description">{description}</p>}
      </div>
      <div className="gallery-section__body">{children}</div>
    </section>
  );
};

export default GallerySection;
